type BackdropSupportOptions = {
  blur?: number | string;
  saturate?: number | string;
};

export const withBackdropSupport = ({
  blur,
  saturate
}: BackdropSupportOptions) => {
  const resolvedBlur = blur ?? "var(--mui-appEffects-glass-blurMd)";
  const resolvedSaturate = saturate ?? "var(--mui-appEffects-glass-saturateMd)";

  const blurValue =
    typeof resolvedBlur === "number" ? `${resolvedBlur}px` : resolvedBlur;

  return {
    "@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px)))":
      {
        backdropFilter: "none",
        WebkitBackdropFilter: "none"
      },
    backdropFilter: `blur(${blurValue}) saturate(${resolvedSaturate})`,
    WebkitBackdropFilter: `blur(${blurValue}) saturate(${resolvedSaturate})`
  };
};
